import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import BlockEmbeddedEntries from './renderOptions/blockEmbeddedEntries';
import InlineEmbeddedEntries from './renderOptions/inlineEmbeddedEntries';
import EmbeddedAsset from './renderOptions/embeddedAsset';
import Heading1 from './renderOptions/heading1';
import Heading2 from './renderOptions/heading2';
import Heading3 from './renderOptions/heading3';
import Heading4 from './renderOptions/heading4';
import Heading5 from './renderOptions/heading5';
import Heading6 from './renderOptions/heading6';
import Hyperlink from './renderOptions/hyperlink';
import Paragraph from './renderOptions/paragraph';
import Blockquote from './renderOptions/blockquote';
import UnorderedList from './renderOptions/unorderedList';

/** @param {FF.ContentfulRenderOptions=} options */
function getContentfulRenderOptions(options = {}) {
  return {
    /** @type {Object.<string, import('@contentful/rich-text-react-renderer').NodeRenderer>} */
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: node =>
        BlockEmbeddedEntries(node, options['BLOCKS.EMBEDDED_ENTRY']),
      [INLINES.EMBEDDED_ENTRY]: InlineEmbeddedEntries,
      [BLOCKS.EMBEDDED_ASSET]: EmbeddedAsset,
      [BLOCKS.HEADING_1]: Heading1,
      [BLOCKS.HEADING_2]: Heading2,
      [BLOCKS.HEADING_3]: Heading3,
      [BLOCKS.HEADING_4]: Heading4,
      [BLOCKS.HEADING_5]: Heading5,
      [BLOCKS.HEADING_6]: Heading6,
      [INLINES.HYPERLINK]: Hyperlink,
      [BLOCKS.PARAGRAPH]: Paragraph,
      [BLOCKS.QUOTE]: Blockquote,
      [BLOCKS.UL_LIST]: UnorderedList,
    },
  };
}

export const contentfulRenderOptions = getContentfulRenderOptions();

/**
 * @param {import('gatsby-source-contentful/rich-text.d').RenderRichTextData<import('gatsby-source-contentful/rich-text.d').ContentfulRichTextGatsbyReference>} body
 * @param {FF.ContentfulRenderOptions=} options
 */
export default function renderContentfulBody(body, options) {
  return renderRichText(body, getContentfulRenderOptions(options));
}
